const filter_params = {
    'tranche' : ['Trancher__c'],
    'project': [ 'Project__r', 'Name','Project__c'],
    'stage': [ 'Stage__r', 'Name', 'Stage__c'],
    'group': [ 'AllocationGroup__c'],
    'allocation': [ 'ProductAllocatedTo__c'],
    'status': [ 'StatusDevr__c'],
//     'type': [ 'ProductType__c'],
    'type': [ 'LatestMasterContract__r', 'MasterContractType__c', 'LatestMasterContract__c'],
    'milestone' : ['Milestone__c'],
    'lot': [ 'Name'],
    // 'constructionstage' : ['LatestMasterContract__r','ContractLifecycle__r','Latest_Stage__c','LatestMasterContract__c']
    // 'constructionstage' : ['LatestMasterContract__r','ContractLifecycle__r','Latest_Stage__c','Project__c']
}

export default filter_params
